function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 2.82051C0 1.26279 1.29602 0 2.89474 0C4.21977 0 5.33686 0.867436 5.68051 2.05128H19.2105C19.6465 2.05128 20 2.39568 20 2.82051C20 3.24534 19.6465 3.58974 19.2105 3.58974H5.68051C5.33686 4.77359 4.21977 5.64103 2.89474 5.64103C1.29602 5.64103 0 4.37824 0 2.82051Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.68051 17.9487C5.33686 19.1326 4.21977 20 2.89474 20C1.29602 20 0 18.7372 0 17.1795C0 15.6217 1.29602 14.359 2.89474 14.359C4.21977 14.359 5.33686 15.2264 5.68051 16.4103H19.2105C19.6465 16.4103 20 16.7547 20 17.1795C20 17.6043 19.6465 17.9487 19.2105 17.9487H5.68051Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0.52631 10C0.52631 9.5752 0.879773 9.23079 1.31578 9.23079H9.05631C9.39999 8.04689 10.517 7.1795 11.8421 7.1795C13.1672 7.1795 14.2842 8.04689 14.6279 9.23079H19.2105C19.6465 9.23079 20 9.5752 20 10C20 10.4248 19.6465 10.7692 19.2105 10.7692H14.6279C14.2842 11.9531 13.1672 12.8205 11.8421 12.8205C10.517 12.8205 9.39999 11.9531 9.05631 10.7692H1.31578C0.879773 10.7692 0.52631 10.4248 0.52631 10Z",
  fill: "white"
});

var SvgFilter = function SvgFilter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFilter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/filter.fa68e906.svg";
export { ForwardRef as ReactComponent };